// Task Cards — combined sets + shared setting labels
import { ESSENTIALS } from "./essentials";
import { GENRES } from "./genres";
import { CREATIVE } from "./creative";
import { WILDLIFE } from "./wildlife";

// Shared, translated labels for the compact "Quick Settings" rows on each card.
export const SETTING_LABELS = {
  mode: { en: "Mode", es: "Modo" },
  aperture: { en: "Aperture", es: "Apertura" },
  shutter: { en: "Shutter", es: "Velocidad" },
  iso: { en: "ISO", es: "ISO" },
  focus: { en: "Focus", es: "Enfoque" },
  wb: { en: "White Bal.", es: "Bal. Blancos" },
  metering: { en: "Metering", es: "Medicion" },
  lens: { en: "Lens", es: "Objetivo" },
  focal: { en: "Focal", es: "Focal" },
  drive: { en: "Drive", es: "Disparo" },
  tip: { en: "Tip", es: "Consejo" },
};

export const TASK_CARD_SETS = [
  {
    id: "essentials",
    icon: "GraduationCap",
    color: "#60A5FA",
    title: { en: "Essentials & Basics", es: "Esenciales y Fundamentos" },
    subtitle: { en: "Core camera operations every photographer must own.", es: "Operaciones basicas de la camara que todo fotografo debe dominar." },
    cards: ESSENTIALS,
  },
  {
    id: "genres",
    icon: "UsersThree",
    color: "#F5A524",
    title: { en: "People, Portraiture & Genres", es: "Personas, Retrato y Generos" },
    subtitle: { en: "Practical guides for portraits and specific shooting scenarios.", es: "Guias practicas para retratos y escenarios especificos." },
    cards: GENRES,
  },
  {
    id: "creative",
    icon: "Sparkle",
    color: "#A78BFA",
    title: { en: "Creative Projects & Composition", es: "Proyectos Creativos y Composicion" },
    subtitle: { en: "Visual styling, composition rules and creative techniques.", es: "Estilo visual, reglas de composicion y tecnicas creativas." },
    cards: CREATIVE,
  },
  {
    id: "wildlife",
    icon: "Bird",
    color: "#34D399",
    title: { en: "Bird & Wildlife Pack", es: "Pack de Aves y Fauna" },
    subtitle: { en: "Ethical, practical field guides for wildlife photography.", es: "Guias de campo eticas y practicas para la fotografia de fauna." },
    cards: WILDLIFE,
  },
];

export const TOTAL_CARDS = TASK_CARD_SETS.reduce((n, s) => n + s.cards.length, 0);
